import { Injectable } from '@angular/core';
import { PartialUpdate } from '@common/interfaces/base';
import { EntityNameType, IEntityInteraction } from '@common/interfaces/entityInteraction';
import { ID } from '@common/interfaces/id';
import { Topics } from '@common/interfaces/topics';
import { AppService } from '@ep-om/app.service';
import { AuthQuery } from '@ep-om/project/auth/auth.query';
import { formatISO } from 'date-fns';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { IssueQuery } from '../issue/issue.query';
import { IssueStore } from '../issue/issue.store';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { EntityInteractionQuery } from './entityInteraction.query';
import { EntityInteractionStore } from './entityInteraction.store';

@Injectable({
  providedIn: 'root'
})
export class EntityInteractionService extends CrudService<IEntityInteraction, EntityInteractionStore, EntityInteractionQuery> {
  constructor(
    protected store: EntityInteractionStore,
    public query: EntityInteractionQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private appService: AppService,
    private authQuery: AuthQuery,
    private issueQuery: IssueQuery,
    private issueStore: IssueStore,
  ) {
    super(
      Topics.ENTITY_INTERACTIONS,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  public register(issueId: ID, entityName: EntityNameType) {
    if (!this.appService.isOnline) {
      return;
    }
    //const now = EP.dateToISO8601();
    const now = formatISO(new Date());
    const userId = this.authQuery.getValue().userId;
    const issue = this.issueQuery.getEntity(issueId);
    const projectId = issue?.projectId;

    if (!userId || !projectId || !issueId || !entityName) {
      console.log("Cannot Register Interaction because of missing properties")
      return;
    }

    // Skip interaction registration for issues still being synced to the backend
    const issueUi = this.issueStore.ui.getValue().entities?.[issueId];
    if (issueUi?.pendingState === 'pending') {
      console.log(`[EntityInteractionService] Skipping interaction registration for issue ${issueId} - still pending sync`);
      return;
    }

    const id = this.store.generateID(userId, issueId, entityName);

    const formerInteraction = this.query.getEntity(id);

    if (!formerInteraction) {
      const newInteraction: IEntityInteraction = {
        id,
        createdAt: now,
        updatedAt: now,
        projectId,
        userId,
        issueId,
        entityName,
        time: now,
      }
      this.create(newInteraction);
    } else {
      const data: PartialUpdate<IEntityInteraction> = {
        id,
        time: now,
      }
      this.update(data);
    }


  }

}
